import '../../stylesheets/nav/nav.css'
import React                                from 'react';
import { useLocation }                      from 'react-router-dom'
import { DEFAULT_NON_DESKTOP_BROWSER }      from '../../_constants/break-points.js'
import { useViewportWidth }                 from '../../hooks/internal/ui/useViewportWidth.js';
import { checkViewportWidthGreaterThan }    from '../../utilities/viewport.js';
import Desktop                              from './desktop/Desktop.js' 
import Hamburger                            from './hamburger/Hamburger.js' 

const Navbar = ( { subscription, paymentMethod } ) => {
    // Get current location from React Router
    const location = useLocation();
    const currentPath = location.pathname;  
    const viewportWidth = useViewportWidth();
    
    const isActive = (path) => {
        return currentPath === path;
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {checkViewportWidthGreaterThan(viewportWidth, DEFAULT_NON_DESKTOP_BROWSER) ? (
                    <Desktop 
                        currentPath={currentPath} 
                        isActive={isActive} 
                        subscription={subscription}
                        paymentMethod={paymentMethod}
                    />
                ) : (
                    <Hamburger 
                        currentPath={currentPath} 
                        isActive={isActive} 
                        subscription={subscription}
                        paymentMethod={paymentMethod}                     
                    />
                )}
            </div>
        </nav>
    );
};

export default Navbar
